// extracted by mini-css-extract-plugin
module.exports = {"section":"Deposit_section__rxzRs","input":"Deposit_input__Ll_xF"};